import React, { FC } from 'react';
import { CreateReadyArtView } from '../components';
import { useParams } from 'react-router';

export const CreateReadyArtPage: FC = () => {
  const { imageId } = useParams<{ imageId: string }>();
  return <CreateReadyArtView imageId={imageId} />;
};
